import { blueGrey } from "@mui/material/colors"
import { makeStyles } from "@mui/styles"

export const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.default,
      "&:hover fieldset": {
        borderColor: blueGrey[200]
      },
      "&.Mui-focused fieldset": {
        borderColor: blueGrey[200],
        borderWidth: 1
      }
    },
    "& .MuiInputBase-input::placeholder": {
      fontWeight: theme.typography.body2.fontWeight,
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.h6.lineHeight,
      color: blueGrey[500],
      opacity: 0.8
    },
    "& .MuiInputBase-input": {
      fontWeight: theme.typography.body2.fontWeight,
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.h6.lineHeight,
      color: blueGrey[500],
      opacity: 1
    }
  }
}))
